/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'invoices': {
    width: 16,
    height: 21,
    viewBox: '0 0 16 21',
    data: '<path pid="0" d="M13.995 19.673a.54.54 0 0 0 .54-.54V2.487a.54.54 0 0 0-.54-.539H1.978a.54.54 0 0 0-.54.54v16.647c0 .298.242.54.54.54h12.017zm0 1H1.978c-.85 0-1.54-.689-1.54-1.54V2.487c0-.85.69-1.539 1.54-1.539h12.017c.85 0 1.54.69 1.54 1.54v16.647c0 .85-.69 1.54-1.54 1.54zm-3.98-5.102c0-.23-.05-.43-.15-.602-.1-.172-.257-.33-.472-.473-.215-.143-.576-.312-1.084-.507v-1.153c.427.037.843.138 1.25.305l.367-.914a4.435 4.435 0 0 0-1.617-.36v-.582h-.535v.598c-.53.052-.941.2-1.237.443a1.154 1.154 0 0 0-.443.932c0 .352.107.647.322.885.215.238.58.459 1.096.662l.262.102v1.21a4.378 4.378 0 0 1-.854-.152 4.5 4.5 0 0 1-.818-.297V16.7c.479.21 1.036.322 1.672.335v.786h.535v-.801c.539-.05.958-.2 1.257-.451.3-.252.45-.584.45-.998zm-1.175.058c0 .248-.177.401-.531.461v-.973c.177.081.31.16.398.235a.351.351 0 0 1 .133.277zm-1.57-2.37c0-.222.168-.358.504-.407v.918a1.415 1.415 0 0 1-.385-.229.37.37 0 0 1-.12-.283zM3.57 5.676h9v-1h-9v1zm0 3h9v-1h-9v1z" _fill="#848484" fill-rule="nonzero"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/invoices.js